import { Stack } from "@mui/material";
import { WorkplaceAvatar } from "@src/appV2/redesign/components/WorkplaceAvatar";
import { SHIFT_DISCOVERY_WORKPLACE_PROFILE_FULL_PATH } from "@src/appV2/redesign/ShiftDiscovery/paths";
import {
  CbhIcon,
  ListItem,
  ListItemButton,
  ListItemText,
  Text,
} from "@src/appV2/redesign/system/ui-components";
import { generatePath, useHistory } from "react-router-dom";

import { OverlappingWorkplaceAvatars } from "../../../components/OverlappingWorkplaceAvatars";
import { DOCUMENT_REQUIRED_BY_WORKPLACES_FULL_PATH } from "../../paths";
import { type ApplicableWorkplacesDetails } from "../../utils/getApplicableWorkplacesTextForRequirement";

interface DocumentDetailsRequiredByWorkplacesListItemProps {
  text: string;
  type: ApplicableWorkplacesDetails["type"];
  requiredWorkplaceIds: string[];
  requirementId: string;
}

export function DocumentDetailsRequiredByWorkplacesListItem(
  props: DocumentDetailsRequiredByWorkplacesListItemProps
) {
  const { text, type, requiredWorkplaceIds, requirementId } = props;
  const history = useHistory();
  const isClickable = type === "WORKPLACE";

  const handleClick = () => {
    if (isClickable) {
      if (requiredWorkplaceIds.length === 1) {
        const workplaceDetailsPath = generatePath(SHIFT_DISCOVERY_WORKPLACE_PROFILE_FULL_PATH, {
          workplaceId: requiredWorkplaceIds[0],
        });
        history.push(workplaceDetailsPath);
      } else {
        history.replace(generatePath(DOCUMENT_REQUIRED_BY_WORKPLACES_FULL_PATH, { requirementId }));
      }
    }
  };

  const getIcon = () => {
    if (type === "ALL") {
      return <CbhIcon type="cbh-bunny-colored" size="medium" />;
    }

    if (type === "PLACE") {
      return <WorkplaceAvatar size="small" />;
    }

    return <OverlappingWorkplaceAvatars workplaceIds={requiredWorkplaceIds} size="small" />;
  };

  const ListItemComponent = isClickable ? ListItemButton : ListItem;

  return (
    <ListItemComponent
      {...(isClickable ? { hideCallToActionIcon: true } : {})}
      onClick={isClickable ? handleClick : undefined}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        {getIcon()}
        <ListItemText>
          <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.primary })}>
            {text}
          </Text>
        </ListItemText>
      </Stack>
    </ListItemComponent>
  );
}
